var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/rrTray.j2"] = require( "macros/rrTray.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-also-bought-with.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/rrTray.j2", false, "product/templates/product-also-bought-with.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("richRelevanceTray")) {
var t_4 = t_1.richRelevanceTray;
} else {
cb(new Error("cannot import 'richRelevanceTray'")); return;
}
context.setVariable("richRelevanceTray", t_4);
output += "<div class=\"dom-product-also-bought-with\">\n    ";
output += "\n    ";
var t_5;
t_5 = (lineno = 4, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.rrRecs.pdp2",(lineno = 4, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.rrRecs.item_page__boughtwith"]))]));
frame.set("recs", t_5, true);
if(frame.topLevel) {
context.setVariable("recs", t_5);
}
if(frame.topLevel) {
context.addExport("recs", t_5);
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "recs")) {
output += "<div class=\"js-standard-rr s-rich-relevance-pdp s-rich-relevance-pdp--also-bought-with\">\n            ";
output += runtime.suppressValue((lineno = 9, colno = 30, runtime.callWrap(t_4, "richRelevanceTray", context, [runtime.makeKeywordArgs({"anEntry": runtime.contextOrFrameLookup(context, frame, "None"),"rrRecs": runtime.contextOrFrameLookup(context, frame, "recs")})])), env.opts.autoescape);
output += "\n        </div>\n        ";
;
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-also-bought-with.j2"] , dependencies)